import { state_ctrl_factory } from 'ww2_analytics/common/state_ctrl';
import { inject_rb_form } from '../form';

const main_view = {
    template: require('./view.html'),
    controller: [
        '$scope', 'runner_battler_api',
        function($scope, runner_battler_api) {
            $scope.get_data_method = runner_battler_api.retention_classic_table;
        },
    ],
};
const state_config = inject_rb_form({
    url: '/retention_classic',
    reloadOnSearch: false,
    data: {
        priority: 900,
        title: 'Retention Classic',
    },
    views: {
        '': main_view,
    },
});

export default state_config;
